export function loadState() {
	try {
		const serializedState = localStorage.getItem('searchState');
		if (serializedState === null) {
			return undefined;
		}
		return JSON.parse(serializedState);
	} catch (err) {
		return undefined;
	}
}

export function saveState(state: any) {
	try {
		const serializedState = JSON.stringify(state);
		localStorage.setItem('searchState', serializedState);
	} catch (err) {
		console.error(err.message);
	}
}